import { action } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';
import {
  addLeagueScore,
  finishLeague,
} from '../match2/leagues/leagues.modifiers';
import { getCurrentLeagueId } from '../match2/leagues/leagues.getters';

export const championsLeagueCheats = createActions({
  cheat_resetChampionsLeague: action((state, _, api) => {
    state.match2.leagues = {};
    state.match2.leaguesAllTimeScore = 0;
    state.match2.leaguePhaseCursor = 0;
    delete state.championsLeague;
  }),
  cheat_scoreChampionsLeague: action((state, score: number, api) => {
    addLeagueScore(state, score, api.date.now());
  }),
  cheat_endCurrentChampionsLeague: action((state, _, api) => {
    const id = getCurrentLeagueId(state);
    const entry = state.match2.leagues[id];
    if (!entry) return;
    addLeagueScore(state, 1, api.date.now());

    finishLeague(state, 1, api.date.now(), id);
    state.match2.leagues[id + '-ended'] = entry;
    delete state.match2.leagues[id];
  }),
});
